import { createRouter, createWebHistory } from "vue-router";
import NotFound from "./src/components/NotFound.vue";
import orionDatas from "./src/components/orionDatas.vue";
import translateItems from "./src/components/translateItems.vue";
import putTranslateItems from "./src/components/putTranslateItems.vue";
import keycloakUsers from "./src/components/keycloakUsers.vue";
import maintenanceInfo from "./src/components/maintenanceInfo.vue";
import linkCollection from "./src/components/linkCollection.vue";
import resourceRecovery from "./src/components/resourceRecovery.vue";

const routes = [
  {
    path: "/",
    name: "systemTop",
    component: linkCollection,
    meta: { title: "やまなしデータPF管理用システム" },
  },
  {
    path: "/data",
    component: orionDatas,
    meta: { title: "データ登録状況 | やまなしデータPF管理用システム" },
  },
  {
    path: "/translate",
    component: translateItems,
    meta: { title: "翻訳テーブルの確認 | やまなしデータPF管理用システム" },
  },
  {
    path: "/translate/item-create",
    component: putTranslateItems,
    meta: { title: "翻訳アイテムの作成 | やまなしデータPF管理用システム" },
  },
  {
    path: "/keycloak",
    component: keycloakUsers,
    meta: {
      title:
        "Keycloakユーザ登録用JSONファイルの作成 | やまなしデータPF管理用システム",
    },
  },
  {
    path: "/maintenance",
    component: maintenanceInfo,
    meta: {
      title: "メンテナンス情報の登録・更新 | やまなしデータPF管理用システム",
    },
  },
  {
    path: "/resource-recovery",
    component: resourceRecovery,
    meta: {
      title:
        "カタログサイトのファイル復元 | やまなしデータPF管理用システム",
    },
  },
  {
    path: "/linkCollection",
    component: linkCollection,
    meta: {
      title: "各システムへのリンク | やまなしデータPF管理用システム",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFound,
    meta: { title: "ページが見つかりません" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const DEFAULT_TITLE = "やまなしデータPF 管理用システム";

router.afterEach((to) => {
  let title = to.meta.title;
  if (title === undefined) {
    document.title = DEFAULT_TITLE;
  } else {
    document.title = title;
  }
});

export default router;
